import {
  looksLikeHtml,
  sanitizeReviewHtml,
} from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-html';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Review body. The text comes from customers: plain text keeps its line breaks, text that carries
 * HTML (the administration can edit reviews) is rendered through an allow-list.
 */
export function ReviewText({ text, className }: { text: string; className?: string }) {
  if (!looksLikeHtml(text)) {
    return <p className={cn('whitespace-pre-line break-words', className)}>{text}</p>;
  }
  return (
    <div
      className={cn('dlz-rich break-words', className)}
      dangerouslySetInnerHTML={{ __html: sanitizeReviewHtml(text) }}
    />
  );
}
